export enum NotificationSettingMode {
    None = "None",
    Daily = "Daily",
    OnRowCreate = "OnRowCreate",
    OnRowUpdate = "OnRowUpdate"
}